<template>
  <!-- contentHtml is sanitized by the Gateway before it is stored -->
  <div
    v-if="contentHtml"
    class="message-html"
    v-html="contentHtml"
  />
  <RichText
    v-else
    :value="content"
    style="white-space: pre-line; width: 100%"
  />
</template>

<script>
import RichText from '@/modules/forms/RichText';

export default {
  props: {
    content: String,
    contentHtml: String,
  },
  components: {
    RichText,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/vars';

.message-html {
  width: 100%;
  overflow-wrap: anywhere;

  ::v-deep {
    p {
      margin: 0 0 0.4em;
    }

    p:last-child {
      margin-bottom: 0;
    }

    h1 {
      font-size: 1.5em;
      font-weight: 700;
    }

    h2 {
      font-size: 1.25em;
      font-weight: 600;
    }

    h3 {
      font-size: 1.1em;
      font-weight: 600;
    }

    ul, ol {
      padding-left: 1.5em;
      margin-bottom: 0.4em;
    }

    blockquote {
      border-left: 3px solid #ddd;
      padding-left: 12px;
      color: #666;
      margin: 0.6em 0;
    }

    pre {
      background: #f4f4f4;
      border-radius: 6px;
      padding: 10px 14px;
      font-size: 13px;
      white-space: pre-wrap;
    }

    hr {
      border: none;
      border-top: 2px solid #e0e0e0;
      margin: 1em 0;
    }

    a {
      color: $blue;
      text-decoration: underline;
    }
  }
}
</style>
